<script>
  import { onMount } from "svelte";
  import { cid, ie11Recommendation, lottery } from "../stores.js";
  import Historyback from "../components/Historyback.svelte";

  const contents = [
    {
      category: "よくあるお問い合わせ",
      faqs: [
        {
          q: "操作途中で、エラーが発生した時、どうすればよいのでしょうか？",
          a:
            "操作の際に「セッションの有効期限が切れています」というメッセージが出た場合は、一度ブラウザ（画面）を閉じていただき、今一度受付サイトURLにアクセスのうえ、お申込のお手続きをお進めください。",
          v: false,
        },
        {
          q: "ファミリーマートでのお支払方法について",
          a:
            "「申込完了通知メール」で「引換票番号（13桁）」をご確認ください。\n \n4から始まる13桁の番号がファミリーマートでのお支払に必要な番号となります。\n \n 【ファミリーマートのFamiポート操作方法】\n \nFamiポートのトップ画面の「GoToEatキャンペーン」ボタンをタッチ\n ↓\n 「4************」（13 桁）を入力して、「OK」ボタンを選択\n ↓\n お支払い方法についてのご注意をご確認のうえ、「同意して利用する」ボタンをタッチ\n ↓\n お支払い・食事券内容などをご確認のうえ、よろしければ「確認」ボタンを選択\n ↓\n Fami ポートより「Fami ポート申込券」（レシート）が発行されます\n ↓\n 「Fami ポート申込券」を30分以内にレジカウンターまでお持ち頂き、代金をお支払ください。\n 支払期限までにお支払いをお願いいたします。\n 全国のファミリーマート店内のFamiポート端末にて24時間お支払い可能です。（※一部Famiポート端末が設置されていない店舗もございます。）\n ※現金または各種クレジットカード 、FamiPay、Tマネー、各種バーコード決済、ポイント（Tポイント、ｄポイント、楽天ポイント）でのお支払いになります。\n※交通系電子マネー、Edy、iD、WAON、QUOカードではお支払いただけません。\n※一部バーコード決済で一度にお支払出来る上限がある場合がございます。詳細は決済サービス提供元にお問合せください。",
          v: false,
        },
        {
          q: "ファミリーマートでのお支払い期日について",
          a:
            "支払期限までにお支払いをしていただく必要があります。期限をすぎますと、申込は無効になりますのでご注意ください。\n支払期限は「申込完了通知メール」にてご確認いただけます。",
          v: false,
        },
        {
          q: "入金発券期間について",
          a:
            "申込完了メールに記載されている入金発券期間前に、チケット代金のお支払、チケットのお受け取りは出来ませんのでご注意ください。\nまた、入金発券期間内にお支払いをしていただく必要があります。期間をすぎますと、申込は無効になりますのでご注意ください。",
          v: false,
        }
      ],
    },
    {
      category: "食事券購入について" + ($lottery ? "（当選者）" : ""),
      faqs: [
        {
          q: "受取方法を確認したい。",
          a: "全国のファミリーマートにてお受け取りいただけます。",
          v: false,
        },
        {
          q: "領収書の発行について",
          a:
            "■ファミリーマートでお支払いされたお客様\n→お支払いをされたファミリーマート店舗のストアスタッフに領収書の発行をお申し付けください。\n※お支払い時にストアスタッフから渡されるレジレシートが必要となります。",
          v: false,
        },
        {
          q: "購入した食事券を紛失してしまった",
          a: "食事券の再発行は行っておりません。あらかじめご了承ください。",
          v: false,
        },
        {
          q: "食事券の最大購入枚数について",
          a: "各都道府県によって異なりますのでご購入時に各キャンペーン事務局にご確認ください。",
          v: false,
        },
        {
          q: "購入した食事券のキャンセル・変更について",
          a:
            "購入完了後の食事券のキャンセル・変更はできません。あらかじめご了承ください。",
          v: false,
        },
      ],
    },
    {
      category: "お支払方法について" + ($lottery ? "（当選者）" : ""),
      faqs: [
        {
          q: "「引換票番号」とは何の番号ですか？",
          a:
            "ファミリーマートで食事券をお支払、発券していただくための13桁の番号（英数字）です。\n \n 引換票番号は「申込完了通知メール」よりご確認いただけます。\n \n  【ファミリーマートのFamiポート操作方法】\n \nFamiポートのトップ画面の「GoToEatキャンペーン」ボタンをタッチ\n ↓\n 「4************」（13 桁）を入力して、「OK」ボタンを選択\n ↓\n お支払い方法についてのご注意をご確認のうえ、「同意して利用する」ボタンをタッチ\n ↓\n お支払い・食事券内容などをご確認のうえ、よろしければ「確認」ボタンを選択\n ↓\n Fami ポートより「Fami ポート申込券」（レシート）が発行されます\n ↓\n 「Fami ポート申込券」を30分以内にレジカウンターまでお持ち頂き、代金をお支払ください。\n 支払期限までにお支払いをお願いいたします。\n 全国のファミリーマート店内のFamiポート端末にて24時間お支払い可能です。（※一部Famiポート端末が設置されていない店舗もございます。）\n ※現金または各種クレジットカード 、FamiPay、Tマネー、各種バーコード決済、ポイント（Tポイント、ｄポイント、楽天ポイント）でのお支払いになります。\n※交通系電子マネー、Edy、iD、WAON、QUOカードではお支払いただけません。\n※一部バーコード決済で一度にお支払出来る上限がある場合がございます。詳細は決済サービス提供元にお問合せください。",
          v: false,
        },
        {
          q: "ファミリーマートでのお支払期限を過ぎてしまった。",
          a:
            "支払期限までにお支払いいただけない場合は、お申込は無効となります。あらかじめ、ご了承ください。",
          v: false,
        },
        {
          q: "支払方法・種類について",
          a:
            "ファミリーマートにて、現金または各種クレジットカード 、FamiPay、Tマネー、各種バーコード決済、ポイント（Tポイント、ｄポイント、楽天ポイント）でのお支払いになります。\n※交通系電子マネー、Edy、iD、WAON、QUOカードではお支払いただけません。\n※一部バーコード決済で一度にお支払出来る上限がある場合がございます。詳細は決済サービス提供元にお問合せください。",
          v: false,
        },
        {
          q: "ファミリーマートでのお支払方法について",
          a:
            "「申込完了通知メール」で「引換票番号（13桁）」をご確認ください。\n \n4から始まる13桁の番号がファミリーマートでのお支払に必要な番号となります。\n \n 【ファミリーマートのFamiポート操作方法】\n \nFamiポートのトップ画面の「GoToEatキャンペーン」ボタンをタッチ\n ↓\n 「4************」（13 桁）を入力して、「OK」ボタンを選択\n ↓\n お支払い方法についてのご注意をご確認のうえ、「同意して利用する」ボタンをタッチ\n ↓\n お支払い・食事券内容などをご確認のうえ、よろしければ「確認」ボタンを選択\n ↓\n Fami ポートより「Fami ポート申込券」（レシート）が発行されます\n ↓\n 「Fami ポート申込券」を30分以内にレジカウンターまでお持ち頂き、代金をお支払ください。\n 支払期限までにお支払いをお願いいたします。\n 全国のファミリーマート店内のFamiポート端末にて24時間お支払い可能です。（※一部Famiポート端末が設置されていない店舗もございます。）\n ※現金または各種クレジットカード 、FamiPay、Tマネー、各種バーコード決済、ポイント（Tポイント、ｄポイント、楽天ポイント）でのお支払いになります。\n※交通系電子マネー、Edy、iD、WAON、QUOカードではお支払いただけません。\n※一部バーコード決済で一度にお支払出来る上限がある場合がございます。詳細は決済サービス提供元にお問合せください。",
          v: false,
        },
        {
          q: "「引換票番号」が分からなくなってしまいました。",
          a:
            "申込完了通知メールは１度しかお送りしないため、メールを削除してしまった場合、再購入となります。",
          v: false,
        },
        {
          q: "ファミリーマートでのお支払い期日について",
          a:
            "支払期限までにお支払いをしていただく必要があります。期限をすぎますと、申込は無効になりますのでご注意ください。\n支払期限は申込完了通知メール内をご確認ください。",
          v: false,
        },
      ],
    },
    {
      category: "引き取り方法について" + ($lottery ? "（当選者）" : ""),
      faqs: [
        {
          q: "どのコンビニエンスストアでも食事券を発券できますか？",
          a:
            "全国のファミリーマート店内のFamiポート端末にて24時間発券可能です。\n（※一部Famiポート端末が設置されていない店舗もございます。）",
          v: false,
        },
        {
          q: "引き取らなかったらキャンセルになりますか？",
          a:
            "期日までに食事券を必ずお受取りください。お支払いが完了していない食事券は、支払期限までにお支払いいただけなかった場合、お申込は無効となります。あらかじめご了承ください。",
          v: false,
        },
        {
          q: "Famiポート申込券の有効期限はありますか？",
          a:
            "Famiポートより、レシートを出力後、30分を経過すると申込券レシートは無効となります。\nその場合、再度Famiポートを操作のうえ、レシートを出力していただき、レジカウンターにレシートをお持ちください。",
          v: false,
        },
        {
          q: "「引換票番号」とは何の番号ですか？",
          a:
            "ファミリーマートで食事券をお支払、発券していただくための13桁の番号（英数字）です。\n \n 引換票番号は「申込完了通知メール」よりご確認いただけます。\n \n  【ファミリーマートのFamiポート操作方法】\n \nFamiポートのトップ画面の「GoToEatキャンペーン」ボタンをタッチ\n ↓\n 「4************」（13 桁）を入力して、「OK」ボタンを選択\n ↓\n お支払い方法についてのご注意をご確認のうえ、「同意して利用する」ボタンをタッチ\n ↓\n お支払い・食事券内容などをご確認のうえ、よろしければ「確認」ボタンを選択\n ↓\n Fami ポートより「Fami ポート申込券」（レシート）が発行されます\n ↓\n 「Fami ポート申込券」を30分以内にレジカウンターまでお持ち頂き、代金をお支払ください。\n 支払期限までにお支払いをお願いいたします。\n 全国のファミリーマート店内のFamiポート端末にて24時間お支払い可能です。（※一部Famiポート端末が設置されていない店舗もございます。）\n ※現金または各種クレジットカード 、FamiPay、Tマネー、各種バーコード決済、ポイント（Tポイント、ｄポイント、楽天ポイント）でのお支払いになります。\n※交通系電子マネー、Edy、iD、WAON、QUOカードではお支払いただけません。\n※一部バーコード決済で一度にお支払出来る上限がある場合がございます。詳細は決済サービス提供元にお問合せください。",
          v: false,
        },
        {
          q: "ファミリーマートでの発券はどのようにするのでしょうか？",
          a:
            "「申込完了通知メール」で「引換票番号（13桁）」をご確認ください。\n \n4から始まる13桁の番号（英数字）がファミリーマートでのお支払に必要な番号となります。\n \n 【ファミリーマートのFamiポート操作方法】\n \nFamiポートのトップ画面の「GoToEatキャンペーン」ボタンをタッチ\n ↓\n 「4************」（13 桁）を入力して、「OK」ボタンを選択\n ↓\n お支払い方法についてのご注意をご確認のうえ、「同意して利用する」ボタンをタッチ\n ↓\n お支払い・食事券内容などをご確認のうえ、よろしければ「確認」ボタンを選択\n ↓\n Fami ポートより「Fami ポート申込券」（レシート）が発行されます\n ↓\n 「Fami ポート申込券」を30分以内にレジカウンターまでお持ち頂き、代金をお支払ください。\n 支払期限までにお支払いをお願いいたします。\n 全国のファミリーマート店内のFamiポート端末にて24時間お支払い可能です。（※一部Famiポート端末が設置されていない店舗もございます。）\n ※現金または各種クレジットカード 、FamiPay、Tマネー、各種バーコード決済、ポイント（Tポイント、ｄポイント、楽天ポイント）でのお支払いになります。\n※交通系電子マネー、Edy、iD、WAON、QUOカードではお支払いただけません。\n※一部バーコード決済で一度にお支払出来る上限がある場合がございます。詳細は決済サービス提供元にお問合せください。",
          v: false,
        },
        {
          q: "「引換票番号」が分からなくなってしまいました。",
          a:
            "申込完了通知メールは１度しかお送りしないため、メールを削除してしまった場合、再購入となります。",
          v: false,
        },
      ],
    },
    {
      category: "サイト環境について",
      faqs: [
        {
          q: "操作途中で、エラーが発生した時、どうすればよいのでしょうか？",
          a:
            "操作の際に「セッションの有効期限が切れています」というメッセージが出た場合は、一度ブラウザ（画面）を閉じていただき、\n今一度受付サイトURLにアクセスのうえ、お申込のお手続きをお進めください。",
          v: false,
        },
        {
          q: "利用推奨環境を教えてください。",
          a: $ie11Recommendation ? "下記のWebブラウザの最新版をご利用ください。\n \n■Webブラウザ（PC）\nGoogle chrome / Safari / Mozilla FireFox / Microsoft Edge / Internet Explorer11以降\n\n■Webブラウザ（スマートフォン）\nGoogle chrome / Safari\n \n上記以外のWebブラウザをご利用の場合、表示が正しく行われないなどの現象が発生する可能性がありますので、ご了承ください。\nまた、当サービスではJavascriptを使用してサービス提供をしております。\nそのため、ご利用のブラウザでJavascriptを有効にしてご利用いただけますようお願いいたします。"
                                 : "下記のWebブラウザの最新版をご利用ください。\n \n■Webブラウザ（PC）\nGoogle chrome / Safari / Mozilla FireFox / Microsoft Edge\n\n■Webブラウザ（スマートフォン）\nGoogle chrome / Safari\n \n上記以外のWebブラウザをご利用の場合、表示が正しく行われないなどの現象が発生する可能性がありますので、ご了承ください。\nまた、当サービスではJavascriptを使用してサービス提供をしております。\nそのため、ご利用のブラウザでJavascriptを有効にしてご利用いただけますようお願いいたします。",
          v: false,
        },
      ],
    },
    {
      category: "その他",
      faqs: [
        {
          q: "購入した食事券のキャンセル・変更はできますか？",
          a:
            "購入された食事券のキャンセル・変更はできません。あらかじめご了承ください。",
          v: false,
        },
        {
          q: "定期メンテナンスはありますか？",
          a:
            "メンテナンスを行う際はサイト上で案内を致しますので、サイトにてご確認ください。",
          v: false,
        },
      ],
    },
    {
      category: "お問い合わせ",
      faqs: [
        {
          q: "その他のお問い合わせがある場合",
          a:
            "FAQをご確認頂いても問題が解決しない場合には、お手数ですが下記サポートメールまで、お名前・お電話番号・お問い合わせ内容を明記のうえ、ご連絡ください。",
          b: {
            t: "お問い合わせフォーム",
            h:
              "https://slib.f.msgs.jp/webapp/form/23288_slib_1/index.do?cid=" +
              $cid,
          },
          p:
            "お問い合わせの際は、｢お名前｣、「お電話番号」、「お問い合わせ内容」を明記してください。\n （返信メールが届かない際など、お電話にてご回答させていただく場合がございます。）\n ◇ 営業時間 10：00 ～ 18：00\n ◇上記営業時間以降のお問い合わせに関しましては、翌日以降の返信とさせていただきます。\n \n ＜問い合わせメールの返信が来ない場合＞\n 迷惑メール対策として､受信の許可･拒否などの設定をされている可能性がございます。\n 受信するには「info.eventify.co.jp」を受信するドメインとしてご登録ください｡\n メールの返信がない場合には、お客様の端末ではドメイン指定がされていません。\n 迷惑メール対策として､受信の許可･拒否などの設定を再度ご確認ください。",
          v: false,
        },
      ],
    },
  ];

  onMount(() => {
    window.scroll(0, 0);
  });

  function collapse(event) {
    var element = event.currentTarget;
    if (element.classList.contains("hide")) {
      element.classList.remove("hide");
      if (!element.classList.contains("show")) element.classList.add("show");
    } else {
      element.classList.add("hide");
      if (element.classList.contains("show")) element.classList.remove("show");
    }
    var content = element.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }
</script>

<style>
.list {
    padding-right: .75rem;
    margin-left: -1rem;
}
</style>

<div class="flex jc-between">
  <h2>FAQ</h2>
  <Historyback />
</div>
<ol>
  {#each contents as content}
    <li>
      <h3>{content.category}</h3>
    </li>
    <div class="list">
      {#each content.faqs as faq}
        <div class="list-item list-item-action">
          <div on:click={collapse} class="faq hide flex jc-between">
            <div class="faq-q">{faq.q}</div>
            <div class="faq-q-ico">
              <svg
              width="1rem"
              height="1rem"
              viewBox="0 0 16 16"
              class="ico down"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z" />
            </svg>
            <svg
              width="1rem"
              height="1rem"
              viewBox="0 0 16 16"
              class="ico up"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z" />
            </svg>
            </div>
          </div>
          <div class="faq-ans">
            <p class="ws-pl">{faq.a}</p>
            {#if faq.b}
              <p><a href={faq.b.h} class="btn btn-info">{faq.b.t}</a></p>
            {/if}
            {#if faq.p}
              <p class="ws-pl">{faq.p}</p>
            {/if}
          </div>
        </div>
      {/each}
    </div>
  {/each}
</ol>
<div class="flex jc-end">
  <Historyback />
</div>
